import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import avatar from './avatar/avatar.js'

export default contract({
  avatar: array([
    avatar
  ]),
})